<template>
    <div class="col-lg-9">
        <div class="card">
            <div class="card-body">
                <div>
                    <div v-if="bill.state === 'COMPLETED'">

                        <h3 class="text-5 text-center mb-3">Wallet Deposit Confirmation</h3>
                        <check-mark class="p-6"></check-mark>
                        <p class="text-center text-4 mb-5">Your payment was successful we have funded your wallet</p>
                        <div class="text-center">
                            <p class="text-sm-center text-3 mb-0 mb-sm-3"><span class="text-muted" >Amount :</span> <strong>{{ bill.payment_currency === 'USD'?'$'+money(bill.amount) : 'ZWG'+money(bill.amount) }}</strong> </p>
                        </div>
                        <div class="text-center">
                            <p class="text-sm-center mb-0 mb-sm-3"><span class="text-muted" >Currency :</span> <strong>{{ bill.payment_currency }}</strong> </p>
                        </div>
                    </div>
                    <div v-if="init || bill.state === 'PROCESSING'">
                        <h3 class="text-5 text-center mb-5">Funding Wallet ... </h3>
                        <div
                            class="text-center text-primary text-20 line-height-07 mb-5 d-flex justify-content-center align-items-center">
                            <div class="loader"></div>
                        </div>
                        <p v-if="countDown > 0" class="text-center text-primary text-8 line-height-07 mb-5">
                            {{ this.countDown }}
                        </p>
                        <p class="text-center text-4 mb-5">Your Payment was successful we are depositing your wallet</p>
                        <p class="text-center text-1">To quickly check progress click below.</p>
                    </div>
                    <div v-if="bill.state === 'FAILED'">
                        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"> <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/> <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                        </svg>
                        <h3 class="text-5 text-center mb-5">Wallet Deposit Confirmation</h3>

                        <p class="text-center text-danger text-4 mb-5">
                            Oops! Looks like the Wallet system is a little unstable right now . Contact Magetsi Support if you need any assistance.
                        </p>

                        <div class="row">
                            <p class="col-sm-4 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Ref : </p>
                            <p class="col-sm-8">{{ transaction.customer_reference }}</p>
                        </div>
                    </div>
                    <div class="form-group d-flex flex-row">
                        <router-link
                            v-if="bill.state === 'COMPLETED'"
                            to="/business/wallets"
                            :class="['btn btn-primary btn-block' , loading ? 'btn-loading' : '']">
                            Back to Wallets
                        </router-link>
                        <button v-if="init || bill.state === 'PROCESSING'"
                                @click.prevent="submit"
                                :class="['btn btn-success btn-block' , loading ? 'btn-loading' : '']">
                            Refresh
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CheckMark from "../../../core/Checkmark.vue";
import {money} from "../../../../core/forms/money";
export default {
    name: "ecocash.vue",
    mixins: [money],
    components: {CheckMark},
    data() {
        return {
            bill: {},
            payment: {},
            transaction: {},
            loading: false,
            init: true,
            countDown: 5,
            ref: this.$route.query.id == null ? this.$route.query.ref : this.$route.query.id
        };
    },
    methods: {
        submit() {
            if (this.loading) {
                return;
            }

            this.loading = true;
            this.countDown = 0;

            // Check Payment

            window.axios['post'](`${window.location.origin}/airtime/complete`, {
                ref: this.ref
            }).then((response) => {

                this.init = false;
                if (response.data.success) {
                    this.bill = response.data.body.bill;
                    this.payment = response.data.body.payment;
                    this.transaction = response.data.body.transaction;
                    if (this.bill.state === 'PROCESSING') {
                        this.countDown = 30;
                        this.startCountDown();
                    }
                }

            }).finally(() => {
                this.loading = false;
            });


        },
        startCountDown() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1;
                    this.startCountDown();
                }, 1000);

            } else {

                if (!this.loading && !this.done) {
                    this.submit();
                }
            }
        },
    },

    mounted() {
        this.submit();
    }
}
</script>

<style scoped>

</style>
